(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snax-halloween-tees"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snaxy-greeting')) {
  class SnaxyGreeting extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas.getContext('2d');
      if (!this.context) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.played = false;
      this.visible = false;
      this.frame = -1;
      this.image = new Image();
      this.image.decoding = 'async';
      this.torso = new Image();
      this.torso.decoding = 'async';
      const ready = () => {
        if (!this.image.complete || !this.image.naturalWidth || !this.torso.complete || !this.torso.naturalWidth) return;
        if (!this.isConnected) return;
        this.loaded = true;
        this.setAttribute('data-ready', '');
        this.draw(0);
        this.update();
      };
      this.image.onload = ready;
      this.torso.onload = ready;
      this.torso.onerror = () => this.removeAttribute('data-ready');
      this.image.onerror = () => this.removeAttribute('data-ready');
      this.near = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.torso.src = this.dataset.torso;
          this.image.src = this.dataset.sprite;
          this.near.disconnect();
        }
      }, {rootMargin: '300px'});
      this.near.observe(this.parentElement);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible && this.running) this.finish();
        this.update();
      }, {threshold: 0.12});
      this.observer.observe(this.parentElement);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) {
          cancelAnimationFrame(this.raf);
          this.running = false;
        }
        this.update();
      }, {signal: this.controller.signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.running) this.finish();
      }, {signal: this.controller.signal});
    }
    draw(frame, y = 105) {
      this.frame = frame;
      const offsets = [[0,0],[5.08,0.41],[14.8,-0.39],[6.34,0.44],[-0.48,11.01],[3.76,10.72],[3.9,10.72],[-1.34,10.71]];
      const sx = Math.round(frame % 4 * this.image.naturalWidth / 4);
      const sy = Math.round(Math.floor(frame / 4) * this.image.naturalHeight / 2);
      const ctx = this.context;
      ctx.clearRect(0, 0, 512, 512);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.save();
      ctx.translate(0, y * 512 / 100);
      ctx.scale(512 / 443.5, 512 / 432);
      ctx.translate(...offsets[frame]);
      ctx.drawImage(this.torso, 440, 750, 340, 145, 163.6, 391, 149.6, 63.8);
      if (frame === 0) {
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(443, 0);
        ctx.lineTo(443, 443);
        ctx.lineTo(314, 443);
        ctx.lineTo(314, 398);
        ctx.lineTo(163, 398);
        ctx.lineTo(163, 443);
        ctx.lineTo(0, 443);
        ctx.closePath();
        ctx.clip();
      }
      ctx.drawImage(this.image, sx, sy, 443, 443, 0, 0, 443, 443);
      ctx.restore();
      this.dataset.frame = String(frame);
      this.dataset.offset = y.toFixed(3);
    }
    update() {
      if (!this.loaded) return;
      if (this.motion.matches) {
        this.draw(2, 6);
        this.dataset.state = 'still';
        return;
      }
      if (this.dataset.state === 'still') {
        this.draw(0, 105);
        this.dataset.state = 'hidden';
      }
      if (this.visible && !this.played && !document.hidden) this.play();
    }
    play() {
      this.played = true;
      this.running = true;
      this.dataset.state = 'playing';
      const poses = [[0,0],[720,1],[920,2],[1190,3],[1350,2],[1490,4],[1650,2],[1790,5],[1950,2],[2090,4],[2250,2],[2460,6],[2570,2],[2830,1],[3000,7]];
      let start;
      const tick = now => {
        if (!this.running || !this.isConnected) return;
        if (start === undefined) start = now;
        const elapsed = now - start;
        if (elapsed >= 4200) { this.finish(); return; }
        let y = 6;
        if (elapsed < 700) {
          const t = elapsed / 700;
          const ease = 1 + 2.70158 * Math.pow(t - 1, 3) + 1.70158 * Math.pow(t - 1, 2);
          y = 105 - 99 * ease;
        } else if (elapsed > 3450) {
          const t = Math.min(1, (elapsed - 3450) / 750);
          y = 6 + 99 * (t * t * (3 - 2 * t));
        }
        let pose = 0;
        for (const [time, frame] of poses) if (elapsed >= time) pose = frame;
        this.draw(pose, y);
        this.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }
    finish() {
      cancelAnimationFrame(this.raf);
      this.running = false;
      this.context.clearRect(0, 0, 512, 512);
      this.dataset.state = 'complete';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.running = false;
      this.near?.disconnect();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('snaxy-greeting', SnaxyGreeting);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snax-movies"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snax-cinema')) {
  customElements.define('snax-cinema', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.querySelectorAll('button.snax-film__play,button.snax-film__thumbnail-play').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => this.play(button), {signal:this.abort.signal});
      });
    }
    reset(film) {
      film.querySelector('iframe')?.remove();
      film.querySelector('.snax-film__media img').hidden = false;
      film.querySelectorAll('button').forEach(control => { control.hidden = false; });
    }
    play(button) {
      this.querySelectorAll('.snax-film').forEach(film => this.reset(film));
      const film = button.closest('.snax-film');
      const media = film.querySelector('.snax-film__media');
      const player = document.createElement('iframe');
      player.title = button.dataset.playerTitle;
      player.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(film.dataset.video) + '?autoplay=1&playsinline=1&rel=0&cc_load_policy=1';
      player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      player.allowFullscreen = true;
      player.referrerPolicy = 'strict-origin-when-cross-origin';
      player.tabIndex = 0;
      media.querySelector('img').hidden = true;
      media.append(player);
      film.querySelectorAll('button').forEach(control => { control.hidden = true; });
      player.focus({preventScroll:true});
      const rect = media.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) media.scrollIntoView({block:'center',behavior:'instant'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.querySelectorAll('iframe').forEach(player => player.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snax-pizza-face"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snax-pizza-player')) {
  let apiPromise;
  const youtubeReady = () => {
    if (window.YT?.Player) return Promise.resolve();
    if (!apiPromise) apiPromise = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        previous?.();
        resolve();
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = reject;
        document.head.append(script);
      }
    });
    return apiPromise;
  };
  customElements.define('snax-pizza-player', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => {
        this.requested = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.ready) this.start();
        else this.prepare();
      });
      this.near = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.near.disconnect();
          this.prepare();
        }
      }, {rootMargin:'600px'});
      this.near.observe(this);
    }
    prepare() {
      if (this.preparing || this.player) return;
      this.preparing = true;
      youtubeReady().then(() => {
        if (!this.isConnected) return;
        const id = this.dataset.video;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        const frame = this.querySelector('template').content.firstElementChild.cloneNode(true);
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?enablejsapi=1&playsinline=1&rel=0&origin=' + encodeURIComponent(location.origin);
        frame.tabIndex = -1;
        this.prepend(frame);
        this.player = new window.YT.Player(frame, {events:{
          onReady: () => {
            this.ready = true;
            this.dataset.ready = 'true';
            if (this.requested) this.start();
          },
          onStateChange: event => {
            this.dataset.playback = String(event.data);
            if (event.data === 1 || event.data === 3) {
              this.button.hidden = true;
              this.button.removeAttribute('aria-busy');
            }
          },
          onAutoplayBlocked: () => {
            this.button.hidden = true;
            this.button.removeAttribute('aria-busy');
          },
          onError: () => {
            this.button.hidden = true;
            this.button.removeAttribute('aria-busy');
          }
        }});
      }).catch(() => {
        this.preparing = false;
        this.button.removeAttribute('aria-busy');
        if (this.requested) window.location.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(this.dataset.video);
      });
    }
    start() {
      this.player.unMute();
      this.player.playVideo();
      this.player.getIframe().tabIndex = 0;
      this.player.getIframe().focus();
    }
    disconnectedCallback() {
      this.near?.disconnect();
      this.player?.destroy();
      this.player = null;
      this.preparing = false;
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
